import { useQuery, useSuspenseQuery } from "@tanstack/react-query";

import { ApiClient } from "../api-client";

import type { GetAllSchoolClassesResponse } from "../generated-api";

export const schoolClassesQueryOptions = () => ({
  queryKey: ["schoolClasses"],
  queryFn: async () => {
    const response = await ApiClient.api.schoolClassControllerGetAllSchoolClasses();
    return response.data;
  },
  select: (data: GetAllSchoolClassesResponse) => data.data,
});

export function useSchoolClasses() {
  return useQuery(schoolClassesQueryOptions());
}

export function useSchoolClassesSuspense() {
  return useSuspenseQuery(schoolClassesQueryOptions());
}
